/**
 * View in charge of the header and notifications.
 */

import $ from 'jquery';
import Backbone from 'backbone';
import BaseView from 'BaseView';
import NotificationView from 'view/notification';
import FsoHelper from 'fso-helper';
import neff from 'neff';
import pxp from 'lib/pxp';
import LoadErrorHeaderMessagingView from 'widgets/loadError-headerMessaging';
import 'bootstrap-dropdown';
import 'bootstrap-modal';
import 'widgets/accessibleModal';
import 'opinionLabComponent';
import 'fso';

export default BaseView.extend({

	el: '.js_globalNavView',

	events: {
		// close modals when clicking on header links
		'click .vx_globalNav-list_secondary a': 'closeModals',
		'click .js_toggleMobileMenu': 'slideToRevealMenu', // New header method
		'click .toggleMenu': 'toggleMenu',
		'click .globalNav a': 'globalNavItemClicked',
		'click .js_globalNavSearchLink': 'launchSearch'
	},

	/*
	 * Initialize the header for the application by adding in analytics
	 * functions and creating an instance of the Notification View.
	 */
	initialize() {

		// Listen to "sessionTimedOut" event trigger from sessionTimer
		this.listenTo(Backbone, 'sessionTimer:sessionTimedOut', this.closeSearch);

		if (!pxp.isTreatment('global_nav_notifications_treatment')) {
			this.notificationView = new NotificationView();
		}

		// Make FSO for glory of PayPal
		if (neff.isEnabled('fso')) {
			let bodyData = $('body').data();
			if (bodyData && bodyData.fsoToken !== '') {
				FsoHelper.dropCookie(bodyData.viewName, bodyData.fsoToken);
			}
		}

		// initialize header warning when there is a service error
		let loadError = this.$el.data('show-warning') === true;
		if (loadError) {
			this.loadErrorHeaderMessagingView = new LoadErrorHeaderMessagingView();
		}

		if (pxp.isTreatment('consumerweb_US_walletexpnodeweb_sws_spotlight_treatment')
				&& !pxp.isTreatment('global_nav_group1_treatment')) {
			try {
				this._SitewideSearch = require('widgets/sitewideSearch');
			} catch (err) {
				return console.warn(`SitewideSearch did not load!`, err); // eslint-disable-line
			}
		}
	},

	/**
	 *    Close any open modals when clicking on header links
	 */
	closeModals(event) {
		let clickingSearchBtn = $(event.currentTarget).hasClass('js_globalNavSearchLink');
		$('.openModal').modal('hide');

		if (!clickingSearchBtn) {
			this.closeSearch(event);
		}
	},

	closeSearch(event) {
		if (this._SitewideSearch) {
			this._SitewideSearch.close();
		}
	},

	/**
	 *  Navigation Menu Link Clicked.
	 */
	globalNavItemClicked() {
		// Mobile devices appear to have two active navigation items when clicking a globalNav link.
		this.$('.globalNav .active').removeClass('active');
	},

	/*
	 *    Open the remote sitewide search component
	 */
	launchSearch(event) {
		if (this._SitewideSearch) {
			event.preventDefault();
			this._SitewideSearch.open(event);
		}
	},

	/**
	 * Toggle the left nav open on mobile devices
	 * Don't need to detect device here since the
	 * toggle button is displayed using media queries
	 */
	slideToRevealMenu(event) {
		event.preventDefault();
		$('body').toggleClass('vx_hasOpenNav');
	},
	toggleMenu(event) {
		event.preventDefault();
		$('body').toggleClass('overlay-open');
	}
});



// WEBPACK FOOTER //
// ./view/header.es6